import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_COLORS } from '../pdfColors';
import { PDFRecordField } from '../types';

import { pdfSafeText } from '../pdfSafeText';

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: PDF_COLORS.greyMid,
    paddingVertical: 4,
    paddingHorizontal: 4,
  },
  rowAlt: {
    backgroundColor: PDF_COLORS.greyLight,
  },
  label: {
    fontSize: 8,
    fontFamily: 'Poppins',
    color: PDF_COLORS.greyDark,
    width: '35%',
  },
  value: {
    fontSize: 8,
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: PDF_COLORS.ink,
    width: '65%',
    lineHeight: 1.3,
  },
});

interface DataGridProps {
  fields: PDFRecordField[];
}

export const DataGrid = ({ fields }: DataGridProps) => {
  const visible = fields.filter((f) => f.label && f.value);
  return (
    <View style={styles.grid}>
      {visible.map((field, i) => (
        <View
          key={i}
          style={[styles.row, i % 2 === 1 ? styles.rowAlt : {}]}
          wrap={false}
        >
          <Text style={styles.label}>{pdfSafeText(field.label)}</Text>
          <Text style={styles.value}>{pdfSafeText(field.value)}</Text>
        </View>
      ))}
    </View>
  );
};
